module.exports = __webpack_public_path__ + "img/cardfinans.c77e0848.svg";